import { getListingPhotoIssueDefinitions } from "@/lib/listingPhotoFeedback";

/**
 * Listing issue types that can be selected when requesting improvements
 */
export interface ListingIssue {
  id: string;
  label: string;
  description: string;
  messageText: string; // Specific message text for this issue
}

export const LISTING_ISSUES: ListingIssue[] = [
  {
    id: "non_descriptive_title",
    label: "Non-descriptive Title",
    description: "Title is too vague or doesn't accurately describe the item",
    messageText:
      "* Title - Make it more specific and descriptive. Include key features, brand, or model where applicable. E.g. '4.5ft by 6ft Bed & Mouka Foam Mattress' is better than 'Bed & Mattress'",
  },
  {
    id: "description_unacceptable",
    label: "Description Issues",
    description:
      "Description contains unacceptable information or needs improvement",
    messageText:
      "* Description - Provide clear, detailed information about the item's condition, features, and specifications. Remove any inappropriate content like address, contact information, invitation to negotiate, etc.",
  },
  ...getListingPhotoIssueDefinitions(),
  {
    id: "pricing_issues",
    label: "Pricing Not Right",
    description: "Price seems too high and doesn't match item value",
    messageText:
      "* Pricing - Review your pricing to ensure it's competitive and reflects the item's condition and market value. Used items pricing work differently. Ideally, 2.5/4 of the price you bought it is a good starting point e.g. if you bought it for #100,000, aim for ~ #62,000 - #65,000. This is a guide, not a law.",
  },
  {
    id: "missing_information",
    label: "Missing Key Information",
    description:
      "Important details like condition, dimensions, or specifications are missing",
    messageText:
      "* Missing Information - In the description box, add essential details like condition, size, brand, model, or any relevant specifications",
  },
  {
    id: "category_mismatch",
    label: "Category Mismatch",
    description: "Item is in the wrong category",
    messageText:
      "* Category - Ensure your item is listed in the most appropriate category for better visibility",
  },
];
